import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import userDaysStatListSaga from './sagas/userDaysStatListSaga';
import userReferralsDaysStatList from './sagas/userReferralsDaysStatList';

export default [
  // Lists
  ...createCombineMapItem('userDaysStatList', createListReduceObject, [
    userDaysStatListSaga
  ]),
  ...createCombineMapItem('userReferralsDaysStatList', createListReduceObject, [
    userReferralsDaysStatList
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userDaysStat/reducers/static/lists/reducersMap.js